import { useRecordContext } from "ra-core";
import { RecordField } from "@/components/admin/record-field";
import { Show } from "@/components/admin/show";
import { Card, CardContent } from "@/components/ui/card";

import { StatusBadge } from "../faromarket-shared/StatusBadge";

const StatusField = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.status} kind="submission_status" />;
};

const EnvironmentField = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.environment} kind="environment" />;
};

const HoneypotField = () => {
  const record = useRecordContext();
  if (!record?.honeypot_triggered)
    return <span className="text-muted-foreground">—</span>;
  return (
    <span className="text-amber-700 dark:text-amber-300 font-medium">
      Acionado
    </span>
  );
};

const PayloadField = () => {
  const record = useRecordContext();
  if (!record?.raw_payload) return null;
  return (
    <details className="rounded-md border border-border p-3">
      <summary className="cursor-pointer text-sm font-medium select-none">
        Mostrar payload bruto
      </summary>
      <pre className="mt-2 text-xs bg-muted/50 rounded-md p-3 overflow-x-auto max-h-96 overflow-y-auto">
        {JSON.stringify(record.raw_payload, null, 2)}
      </pre>
    </details>
  );
};

export const FormSubmissionShow = () => (
  <Show>
    <Card>
      <CardContent className="grid gap-4 md:grid-cols-2">
        <RecordField
          source="status"
          label="resources.form_submissions.fields.status"
        >
          <StatusField />
        </RecordField>
        <RecordField
          source="environment"
          label="resources.form_submissions.fields.environment"
        >
          <EnvironmentField />
        </RecordField>
        <RecordField
          source="source"
          label="resources.form_submissions.fields.source"
        />
        <RecordField
          source="form_name"
          label="resources.form_submissions.fields.form_name"
        />
        <RecordField
          source="conversion_event"
          label="resources.form_submissions.fields.conversion_event"
        />
        <RecordField
          source="honeypot_triggered"
          label="resources.form_submissions.fields.honeypot_triggered"
        >
          <HoneypotField />
        </RecordField>
        <RecordField
          source="page_url"
          label="resources.form_submissions.fields.page_url"
          className="md:col-span-2"
        />
        <RecordField
          source="referrer_url"
          label="resources.form_submissions.fields.referrer_url"
          className="md:col-span-2"
        />
        <RecordField
          source="landing_page_url"
          label="resources.form_submissions.fields.landing_page_url"
          className="md:col-span-2"
        />
        <RecordField
          source="user_agent"
          label="resources.form_submissions.fields.user_agent"
          className="md:col-span-2"
        />
        <RecordField
          source="ip_hash"
          label="resources.form_submissions.fields.ip_hash"
        />
        <RecordField
          source="processed_at"
          label="resources.form_submissions.fields.processed_at"
        />
        <RecordField
          source="processing_error"
          label="resources.form_submissions.fields.processing_error"
          className="md:col-span-2"
        />
        <RecordField
          source="created_at"
          label="resources.form_submissions.fields.created_at"
        />
        <div className="md:col-span-2 mt-2">
          <PayloadField />
        </div>
      </CardContent>
    </Card>
  </Show>
);
